import { render } from "./frequencyLimit.vue?vue&type=template&id=54929b7e&scoped=true"
import script from "./frequencyLimit.vue?vue&type=script&lang=js"
export * from "./frequencyLimit.vue?vue&type=script&lang=js"

import "./frequencyLimit.vue?vue&type=style&index=0&id=54929b7e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-54929b7e"

export default script